import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import moment, { Moment } from 'moment'

import Dropdown from '../../App/Components/Dropdown/Dropdown'
import Spinner from '../../App/Components/Spinner/Spinner'
import DateRangeSelection from '../DateRangeSelection/DateRangeSelection'

import Client from './Client/Client'
import { IResult } from './Client/IResult'
import ReportTable from './ReportTable'
import style from './style.scss'

const TopCustomerReport: FunctionComponent = () => {
    const { t } = useTranslation()
    const [result, setResult] = useState<IResult[] | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [from, setFrom] = useState<Moment>(moment().startOf('isoWeek'))
    const [to, setTo] = useState<Moment>(moment().endOf('isoWeek'))
    const [amount, setAmount] = useState<number>(5)

    const [span, setSpan] = useState<'year' | 'month' | 'week'>('week')

    const fetchData = async () => {
        setIsLoading(true)

        const newResult = await Client.getData(from, to, amount)

        setResult(newResult)
        setIsLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, [from, to, span, amount])

    return (
        <>
            <h1>{t('Top customers')}</h1>

            <div>
                <div className={style.form}>
                    <DateRangeSelection
                        onSelected={(newSpan, newFrom, newTo) => {
                            setSpan(newSpan)
                            setFrom(newFrom)
                            setTo(newTo)
                        }}
                        from={from}
                        to={to}
                        span={span}
                        availableSpans={['week', 'month', 'year']}
                        showDateFormat={true}
                    />
                    <div className={style.topSelect}>
                        <span>{t('Top')}</span>
                        <Dropdown
                            value={amount}
                            onChange={(event) =>
                                setAmount(parseInt(event.currentTarget.value))
                            }
                        >
                            {[5, 10, 20, 50, 100].map((option) => (
                                <option
                                    key={`topAmount${option}`}
                                    value={option}
                                >
                                    {option}
                                </option>
                            ))}
                        </Dropdown>
                    </div>
                </div>
                {isLoading || null === result ? (
                    <Spinner />
                ) : (
                    <>
                        <ReportTable result={result} />
                    </>
                )}
            </div>
        </>
    )
}

export default TopCustomerReport
